import React, { useState } from 'react';
import {
    Users,
    ChevronDown,
    ChevronRight,
    DollarSign,
    BarChart3,
    Brain,
    Heart,
    Settings,
    Shield,
    FileText,
    Activity,
    Bell,
    Building2,
    Package
} from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import './Sidebar.scss';

const Sidebar = ({ activeSection, onSectionChange }) => {
    const [expandedSections, setExpandedSections] = useState({
        'users': true,
        'payments': true
    });
    const { t } = useLanguage();

    // Admin.js route'larına göre menü yapısı - suboption'lı
    const menuItems = [
        {
            id: 'users',
            label: t('userManagement'),
            icon: <Users size={20} />,
            subItems: [
                { id: 'user-list', label: t('allUsers') }
                // User Analytics'i kaldırdım - tek seçenek
            ]
        },
        {
            id: 'organizations',
            label: t('organizationManagement'),
            icon: <Building2 size={20} />,
            subItems: [
                { id: 'org-list', label: t('allOrganizations') },
                { id: 'org-create', label: t('provisionOrganization') }
            ]
        },
        {
            id: 'plans',
            label: t('planManagement'),
            icon: <Package size={20} />,
            subItems: [
                { id: 'plan-list', label: t('allPlans') }
            ]
        },
        {
            id: 'payments',
            label: t('paymentManagement'),
            icon: <DollarSign size={20} />,
            subItems: [
                { id: 'payment-list', label: t('allPayments') },
                { id: 'revenue-stats', label: t('revenueStats') }
            ]
        },
        {
            id: 'analytics',
            label: t('systemAnalytics'),
            icon: <BarChart3 size={20} />,
            subItems: [
                { id: 'general-stats', label: t('generalStats') },
                { id: 'usage-analytics', label: t('usageAnalytics') }
            ]
        },
        {
            id: 'ai',
            label: t('aiMonitoring'),
            icon: <Brain size={20} />,
            subItems: [
                { id: 'ai-usage', label: t('aiUsage') },
                { id: 'ai-costs', label: t('aiCosts') }
            ]
        },
        {
            id: 'motivation',
            label: t('motivationSystem'),
            icon: <Heart size={20} />,
            subItems: [
                { id: 'motivational-messages', label: t('motivationalMessagess') },
                { id: 'motivation-stats', label: t('motivationStatss') }
            ]
        },
        {
            id: 'notifications',
            label: t('notificationManagement'),
            icon: <Bell size={20} />,
            subItems: [
                { id: 'send-notification', label: t('sendNotification') },
                { id: 'notification-history', label: t('notificationHistory') }
            ]
        },
        {
            id: 'reports',
            label: t('reports'),
            icon: <FileText size={20} />,
            subItems: [
                { id: 'custom-reports', label: t('customReportss') }
            ]
        },
        {
            id: 'health',
            label: t('systemHealth'),
            icon: <Activity size={20} />,
            subItems: [
                { id: 'system-health', label: t('systemStatus') }
            ]
        }
    ];

    const toggleSection = (sectionId) => {
        setExpandedSections(prev => ({
            ...prev,
            [sectionId]: !prev[sectionId]
        }));
    };

    const handleSubItemClick = (subItemId) => {
        onSectionChange(subItemId);
    };

    return (
        <aside className="admin-sidebar">
            <nav className="sidebar-nav">
                {menuItems.map(item => (
                    <div key={item.id} className="sidebar-section">
                        <div
                            className={`section-header ${expandedSections[item.id] ? 'expanded' : ''}`}
                            onClick={() => toggleSection(item.id)}
                        >
                            <div className="section-title">
                                {item.icon}
                                <span>{item.label}</span>
                            </div>
                            {expandedSections[item.id] ?
                                <ChevronDown size={16} /> :
                                <ChevronRight size={16} />
                            }
                        </div>

                        {expandedSections[item.id] && (
                            <div className="sub-items">
                                {item.subItems.map(subItem => (
                                    <div
                                        key={subItem.id}
                                        className={`sub-item ${activeSection === subItem.id ? 'active' : ''}`}
                                        onClick={() => handleSubItemClick(subItem.id)}
                                    >
                                        {subItem.label}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </nav>
        </aside>
    );
};

export default Sidebar;